
export default {
  data() {
    return {
      dataTable: [
        {
          name: 'Tutuanna',
          val1: 365,
          val2: '171'
        },
        {
          name: 'Tutuanna Store',
          val1: 365,
          val2: '171'
        },
        {
          name: 'Keyword',
          val1: 365,
          val2: '171'
        },
        {
          name: 'Keyword',
          val1: 365,
          val2: '171'
        },
        {
          name: 'Keyword',
          val1: 365,
          val2: '171'
        }
      ],
      overviewSelection: 'region',
      series: [
        {
          name: 'Desktops',
          data: [10, 41, 35, 51, 49, 62, 69, 91, 148]
        },
        {
          name: 'Laptops',
          data: [10, 31, 98, 51, 49, 62, 19, 21, 148]
        }
      ],
      chartOptions: {
        chart: {
          height: 350,
          type: 'line',
          zoom: {
            enabled: false
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'straight'
        },
        title: {
          text: 'Product Trends by Month',
          align: 'left'
        },
        grid: {
          row: {
            colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
            opacity: 0.5
          }
        },
        xaxis: {
          categories: [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep'
          ]
        }
      }
    };
  }
};
